<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DU7SQj/tc-custom/9780061745287.jpg?1732137007740" alt="This image is the cover for the book Is It a Choice?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Is It a Choice?
      </h1>
      <p class="bookDescription body article font2">
        <p>The answers to all the questions you've ever had about sexual orientation but were afraid to ask. Eric Marcus provides insightful, no-nonsense answers to hundreds of the most commonly asked questions about same-sex orientation. Offering frank and accepting insight on everything you've always wanted-and needed-to know about same-gender relationships, coming out, family roles, politics, and much more, including:</p> <p>How do you know if you're gay or lesbian?</p><p>What should you do if your child is gay or lesbian?</p><p>Do gay parents raise gay children?</p><p>What does the Bible say about homosexuality?</p><p><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Marcus
      </h2>
      
      <p class="authorDescription body article"><P> Eric Marcus is the author of several books and coauthor of <I> Breaking the Surface</I>, the number one <I> New York Times</I> bestselling autobiography of Olympic diving champion Greg Louganis. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bac0d50a